import {
  Box,
  Button,
  Divider,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import {
  BILLING_PLAN_INTERVAL_MONTHLY,
  BILLING_PLAN_INTERVAL_YEARLY,
} from "apps/simplified-web/src/_components/details/constants";
import { currencyFormatter } from "apps/simplified-web/src/_utils/currencyFormatter";
import { useTranslation } from "react-i18next";

function TldrPlanSwitchConfirmationModal({
  show,
  onHide,
  onYes,
  loading,
  grade,
  newSubscription,
  cartData,
}) {
  const { t } = useTranslation(["billing"]);

  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };

  return (
    <Modal isOpen={show} onClose={onHide} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="4">
          {t("plan_switch_confirmation_modal.modal_title", {
            title: capitalize(grade),
            plan: newSubscription?.product?.name,
          })}
        </ModalHeader>
        <ModalCloseButton />
        <Divider my="0" />
        <ModalBody p="4">
          <Box
            h="inherit"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <HStack
              w="full"
              height="inherit"
              alignItems="stretch"
              align="flex-start"
            >
              <Box flexBasis={0} flexGrow={1}>
                <Text mb={3} fontWeight={500} fontSize="2xl" color="white">
                  {t("braintree_modal.summary")}
                </Text>
                <Text fontSize="md" color="white" mb={4}>
                  {t("braintree_modal.currency")}
                  <Text ml={1} as="span" color={"brand.primary"}>
                    {newSubscription?.currency
                      ? newSubscription?.currency.toUpperCase()
                      : "USD"}
                  </Text>
                </Text>

                <Divider />
                {cartData ? (
                  cartData?.items?.map((item) => (
                    <HStack
                      key={item.id}
                      justify="space-between"
                      align={"flex-start"}
                      my={4}
                    >
                      <Text fontSize="md" color="gray.100">
                        {item.extra?.product_name}{" "}
                        {item.extra?.interval &&
                          `(${
                            item.extra?.interval ===
                            BILLING_PLAN_INTERVAL_MONTHLY
                              ? t("choose_plan_and_pay_modal.month")
                              : item.extra?.interval ===
                                BILLING_PLAN_INTERVAL_YEARLY
                              ? t("choose_plan_and_pay_modal.year")
                              : null
                          })`}
                      </Text>
                      <Text fontSize="md" color="gray.100" fontWeight={500}>
                        {item?.quantity && item?.product_type === "seats"
                          ? `${item?.quantity} x ${currencyFormatter(
                              item?.unit_price
                            )}`
                          : `${currencyFormatter(
                              item?.unit_price,
                              newSubscription?.currency
                            )}`}
                      </Text>
                    </HStack>
                  ))
                ) : (
                  <HStack justify="space-between" align={"flex-start"} my={4}>
                    <Text fontSize="md" color="gray.100">
                      {newSubscription?.product.name}{" "}
                      {newSubscription?.recurring?.interval &&
                        `(${
                          newSubscription?.recurring?.interval ===
                          BILLING_PLAN_INTERVAL_MONTHLY
                            ? t("choose_plan_and_pay_modal.month")
                            : newSubscription?.recurring?.interval ===
                              BILLING_PLAN_INTERVAL_YEARLY
                            ? t("choose_plan_and_pay_modal.year")
                            : null
                        })`}
                    </Text>
                    <Text fontSize="md" color="gray.100" fontWeight={500}>
                      {currencyFormatter(
                        newSubscription?.unit_amount / 100,
                        newSubscription?.currency
                      )}
                    </Text>
                  </HStack>
                )}

                <Divider />
                <HStack justify="space-between" align="flex-start" my={4}>
                  <Text color="gray.300" fontSize="md">
                    {t("braintree_modal.total")}
                  </Text>
                  <Text color={"brand.success"} fontSize="md" fontWeight={500}>
                    {cartData
                      ? currencyFormatter(
                          cartData?.total,
                          newSubscription?.currency
                        )
                      : currencyFormatter(
                          newSubscription?.unit_amount / 100,
                          newSubscription?.currency
                        )}
                  </Text>
                </HStack>
                <Divider />
              </Box>
            </HStack>
          </Box>
          <Box w="full" mt={4}>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                onYes();
              }}
              colorScheme="primary"
              variant="solid"
              isLoading={loading}
              loadingText={
                grade === "downgrade"
                  ? grade.slice(0, -1) + "ing ..."
                  : grade + "ing ..."
              }
              size="lg"
              w="full"
            >
              {capitalize(grade)}
            </Button>
          </Box>
        </ModalBody>
        <Divider my="0" />
      </ModalContent>
    </Modal>
  );
}

export default TldrPlanSwitchConfirmationModal;
